import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./context/AuthContext.js";
import { ProductProvider } from "./context/ProductContext.js";
import { ThemeProvider } from "./context/ThemeContext.js";
import { DataTransferProvider } from "./context/DataTransferContext.js";
import { SearchProvider } from "./context/SearchContext.js";
import { CartProvider } from "./context/CartContext.js";
import { useCookies } from "react-cookie";

import TypingMyOrders from "./pages/TypingMyOrders.js";
import HomePage from "./pages/HomePage.js";
import TypingModule from "./pages/TypingModule.js";
import TypingPerformance from "./pages/TypingPerformance.js";
import TypingPerformanceTest from "./pages/TypingPerformanceTest.js";
import TypingParagraph from "./pages/TypingParagraph.js";
import TypingExamSelection from "./pages/TypingExamSelection.js";
import Footer from "./layouts/footer/Footer.js";
import AboutUs from "./pages/footer-pages/AboutUs.js";
import TermAndCondition from "./pages/footer-pages/TermsConditions.js";
import PrivacyPolicy from "./pages/footer-pages/PrivacyPolicy.js";
import RefundPolicy from "./pages/footer-pages/RefundPolicy.js";
import ContactUs from "./pages/footer-pages/ContactUs.js";
import NotFound from "./pages/error/NotFound.js";
import CoinPage from "./pages/coin-pages/Coinpage.js";
import SitemapPage from "./layouts/sitemap/Sitemap.js";
import TypingTransactionModal from "./TransactionStatus/TypingTransactionModal.js";
import GlobalSearch from "./components/GlobalSearch/GlobalSearch.js";
import Term from "./components/Tern.js";

function KeepSearchRedirect({ to, replace = true }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace={replace} />;
}
function App() {
  const [cookies] = useCookies(["token"]);
  const [hasAccess, setHasAccess] = useState(null);

  useEffect(() => {
    const checkAccess = async () => {
      if (!cookies.token) {
        setHasAccess(false);
        return;
      }

      try {
        const res = await fetch(
          "https://auth.ssccglpinnacle.com/api/checkAccessTypingProduct",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${cookies.token}`,
            },
            body: JSON.stringify({ product_id: "999" }),
          }
        );

        const data = await res.json();
        if (data.access === "access" || data.hasAccess === true) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }
      } catch (err) {
        console.error("Error checking access:", err);
        setHasAccess(false);
      }
    };

    checkAccess();
  }, [cookies.token]);

  if (hasAccess === null) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-lg font-semibold text-gray-600">
          Checking access...
        </p>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId="991105793073-1dikvgcrhdiqahsm2056906unah9tpnb.apps.googleusercontent.com">
      <BrowserRouter>
        <AuthProvider>
          <ProductProvider>
            <ThemeProvider>
              <DataTransferProvider>
                <CartProvider>
                  <SearchProvider>
                    <Routes>
                      {hasAccess === true && (
                        <Route
                          path="/"
                          element={
                            <Navigate to="/typingExamSelection" replace />
                          }
                        />
                      )}
                      {hasAccess === false && (
                        <Route path="/" element={<HomePage />} />
                      )}

                      <Route
                        path="/typingExamSelection"
                        element={<TypingExamSelection />}
                      />
                      <Route
                        path="/typing"
                        element={
                          <KeepSearchRedirect to="/typingExamSelection" />
                        }
                      />
                      <Route
                        path="/buy/typing-pass"
                        element={
                          <KeepSearchRedirect to="/typingExamSelection" />
                        }
                      />
                      <Route path="/referral" element={<Term />} />
                      <Route path="/myorders" element={<TypingMyOrders />} />
                      <Route
                        path="/typingmodule/:testcode/:exam/:category"
                        element={<TypingModule />}
                      />
                      <Route
                        path="/payment-status"
                        element={<TypingTransactionModal />}
                      />
                      <Route
                        path="/typingparagraph/:exam/:category"
                        element={<TypingParagraph />}
                      />
                      <Route
                        path="/typingperformance/:accuracy/:wrongper/:actualdep/:speed/:testcode/:exam/:category"
                        element={<TypingPerformance />}
                      />
                      <Route
                        path="/typingperformancetest/:accuracy/:wrongper/:actualdep/:speed/:testcode/:exam/:category"
                        element={<TypingPerformanceTest />}
                      />
                      <Route path="/coins" element={<CoinPage />} />
                      <Route path="/about-us" element={<AboutUs />} />
                      <Route path="/contact-us" element={<ContactUs />} />
                      <Route
                        path="/privacy-policy"
                        element={<PrivacyPolicy />}
                      />
                      <Route path="/refund-Policy" element={<RefundPolicy />} />
                      <Route
                        path="/terms-and-condition"
                        element={<TermAndCondition />}
                      />
                      <Route path="/sitemap" element={<SitemapPage />} />
                      <Route path="/global-search" element={<GlobalSearch />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>

                    <Footer />
                  </SearchProvider>
                </CartProvider>
              </DataTransferProvider>
            </ThemeProvider>
          </ProductProvider>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
